import { render } from "./SlideOverPanel.vue?vue&type=template&id=1b3b010b"
import script from "./SlideOverPanel.vue?vue&type=script&lang=js"
export * from "./SlideOverPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__